<template>
  <div class="container-fluid px-1">
    <div class="row justify-content-center">
      <div class="col-12 col-md-8 col-lg-6">
        <div class="card shadow-sm my-3 overflow-hidden mx-0">
          <div class="d-flex justify-content-between align-items-center bg-light border-bottom p-2">
            <div>
              <div v-if="ordenCompraDetailSelected.numero_orden">
                <h6 class="h6 font-weight-bold text-dark mb-0">
                  Número Orden Compra {{ ordenCompraDetailSelected.numero_orden }}
                </h6>
              </div>
              <div v-if="!ordenCompraDetailSelected.numero_orden">
                <h6 class="h6 font-weight-bold text-dark mb-0">
                  Sin Orden De Compra
                </h6>
              </div>
              <label v-if="agregar_producto.producto" class="text-success d-block">
                {{ agregar_producto.producto.nombre }}
              </label>
              <small v-else class="text-muted d-block">
              </small>
              <small v-if="agregar_producto.producto && agregar_producto.producto.sku"
                class="text-dark d-block font-weight-bold">
                {{ agregar_producto.producto.sku }}
              </small>
            </div>
            <button class="btn btn-danger btn-sm rounded" @click="$router.back()">
              cerrar
            </button>
          </div>
          <div class="card shadow-sm border-0 my-4" :class="semaphoreClass">
            <div class="card-body p-2">


              <small v-if="sinOC === true && agregar_producto.producto && agregar_producto.producto.is_comodin == false" class="form-text text-danger d-flex align-items-center mt-2">
                <i class="fas fa-exclamation-circle mr-2"></i>
                (Sin Orden de Compra)
              </small>

               <small v-if="sinOC === true && agregar_producto.producto && agregar_producto.producto.is_comodin == true" class="form-text text-danger d-flex align-items-center mt-2">
                <i class="fas fa-exclamation-circle mr-2"></i>
                (Producto Comodín)
              </small>

              <!-- Header con información de estado -->
              <div class="d-flex justify-content-between align-items-center pb-2 border-bottom">
                <div class="d-flex align-items-center">
                  <i class="fas fa-box-open text-dark mr-2" style="font-size: 1.25rem;"></i>
                  <div>
                    <small class="text-muted d-block">Pendiente</small>
                    <strong class="h5 mb-0 text-dark">{{ 
                      (ordenCompraDetailSelected && ordenCompraDetailSelected.orden_compra_d && ordenCompraDetailSelected.orden_compra_d.unidad_medida) && 
                      (agregar_producto.producto && agregar_producto.producto.is_comodin == false && sinOC == false) 
                      ? Math.max(0, Math.trunc(pendienteActualizadoOCD /
                        ordenCompraDetailSelected.orden_compra_d.unidad_medida.cantidad_unidades
                        ) - Number(agregar_producto.cantidad || 0)) : 0 
                    }}</strong>
                  </div>
                </div>
                <div class="text-right">
                  <small class="text-muted d-block">Tipo</small>
                  <span class="badge badge-dark badge-pill px-3 py-2 mb-2">{{ estadoEnOC }}</span>
                </div>
              </div>
              <div class="my-3">
                <div class="d-flex align-items-center">
                  <input ref="cantidadInputRef" type="text" v-model="cantidadInput" @blur="onCantidadBlur"
                    class="form-control form-control-lg text-center font-weight-bold p-0"
                    style="font-size: 2.5rem; height: 5rem; letter-spacing: 0.05em; flex: 1;" placeholder="Cantidad"
                    inputmode="numeric" required :class="{ 'is-invalid': cantidadError }" />
                  <button @click="insertMultiply" class="btn btn-md btn-dark ml-1" type="button"
                    style="height: 60px">X</button>
                </div>
                <small v-if="cantidadError" class="form-text text-danger d-flex align-items-center mt-2">
                  <i class="fas fa-exclamation-circle mr-2"></i>
                  {{ agregar_producto.errors.cantidad }}
                </small>
              </div>

              <!-- HINT PARA SIN OC -->
              <div v-if="sinOC === true && agregar_producto.producto && agregar_producto.producto.is_comodin == false" class="alert alert-info border-0 mt-2 mb-3 text-left shadow-sm" style="border-radius: 8px; font-size: 15px;">
                <i class="fas fa-info-circle"></i>&nbsp; <strong>Consejo Importante:</strong> <br>
                Los productos ingresados que son <strong>No Solicitados</strong> se deben convertir obligatoriamente a Unidad.
                <br>
                Por Ejemplo, si recibe (1) fardo/12, Deben agregarse como (12) en vez de (1).
              </div>

              <div class="mb-3">

                <!-- 

                ANTIGUO SELECT LEGACY

                <select v-model="selectedOrdenIndex" @change="onOrdenCompraInfoSelect($event.target.value)"
                  class="form-control form-control-lg custom-select">
                  <option v-for="item in availableUoMs" :key="item.unidad_medida.id" :value="item.unidad_medida.id">
                    {{ item.unidad_medida.nombre }}
                  </option>
                </select> 
                
                -->

                <!-- SELECT PARA INGRESO SIN OC DETALLE O COMODIN-->
                <div v-if="agregar_producto.producto && (agregar_producto.producto.is_comodin == true || sinOC == true)">
                  <select v-model="selectedOrdenIndex" @change="onOrdenCompraInfoSelect($event.target.value)"
                    class="form-control form-control-lg custom-select">
                    <option v-for="item in availableUoMs" :key="item.unidad_medida.id" :value="item.unidad_medida.id">
                      {{ item.unidad_medida.nombre }}
                    </option>
                  </select>
                </div>

                <!-- SELECT PARA INGRESO CON OC DETALLE-->
                <div v-if="agregar_producto.producto && (agregar_producto.producto.is_comodin == false && sinOC == false)">
                  <select v-model="selectedDynamicUoMIndex" @change="onOrdenCompraSelectDynamicUoM($event.target.value)"
                    class="form-control form-control-lg custom-select">
                    <option v-for="item in availableDynamicUoMs" :key="item.id" :value="item.id">
                      {{ item.nombre }} - OC #{{ item.numero_orden }} {{ obtenerEstado(item.orden_compra_d.tipo) }}
                    </option>
                  </select>
                </div>


                
                <!-- Mensaje de error -->
                <small v-if="agregar_producto.errors && agregar_producto.errors.unidad_recepcion"
                  class="form-text text-danger d-flex align-items-center mt-2">
                  <i class="fas fa-exclamation-circle mr-2"></i>
                  {{ agregar_producto.errors.unidad_recepcion[0] }}
                </small>
              </div>
              <!-- Lote info -->
              <div v-if="isRegistrarLote" class="lote-registration-container">
                <div class="form-group">
                  <div class="input-group">
                    <input id="lote-input-html" type="text" class="form-control" v-model="lotes.lote"
                      placeholder="Ingresa Lote" />
                    <div class="input-group-append" v-if="!currentStep">
                      <button class="btn btn-dark" type="button" @click="validarLote">
                        Validar
                      </button>
                    </div>
                  </div>
                </div>
                <div v-if="currentStep === 'crear_lote'">
                  <div class="form-group">
                    <label for="fecha-prod-html">Fecha de Producción</label>
                    <input id="fecha-prod-html" v-model="lotes.fecha_produccion" type="date" class="form-control" />
                  </div>
                  <div class="form-group">
                    <label for="fecha-vence-html">Fecha de Vencimiento</label>
                    <input id="fecha-vence-html" v-model="lotes.fecha_vencimiento" type="date" class="form-control" />
                  </div>
                  <button class="btn btn-success btn-block" type="button" @click="guardarFechas">
                    Guardar Fechas
                  </button>
                  <button class="btn btn-link btn-block" type="button" @click="cancelarRegistroFechas">
                    Cancelar
                  </button>
                </div>

                <div v-if="currentStep === 'lote_creado'" class="mt-3 text-center">
                  <strong>Lote:</strong> {{ lotes.lote }}<br>
                  <strong>Vence:</strong> {{ formattedVencimiento }}
                </div>
              </div>

            </div>
            <div class="card-body">
              <div class="form-section">
                <!-- Status Buttons -->
                <div class="status-buttons">
                  <button v-for="status in availableStatuses" :key="status.tipo" type="button" class="btn-status"
                    :class="{
                      'active btn-success': status.tipo === 'A' && agregar_producto.estado === 'A',
                      'active btn-info': status.tipo === 'B' && agregar_producto.estado === 'B',
                      'active btn-dark': status.tipo === 'P' && agregar_producto.estado === 'P',
                    }" style="pointer-events: none;">
                    {{ status.nombre }}
                  </button>
                </div>


                <!-- INPUTS PARA PRODUCTO COMODIN -->
                <div v-if="agregar_producto.producto && agregar_producto.producto.is_comodin == true" class="form-group">


                  <label class="form-label">Descripción de Producto Comodín</label>
                  <textarea v-model="agregar_producto.descripcion" class="form-control input-secondary"
                    placeholder="Descripción"
                    :class="{ 'is-invalid': agregar_producto.errors && agregar_producto.errors.descripcion }">
                  </textarea>
                  <small v-if="agregar_producto.errors && agregar_producto.errors.descripcion" class="text-danger">
                    {{ agregar_producto.errors.descripcion[0] }}
                  </small>
                  <label class="mt-2">Precio Línea Total</label>
                  <input type="number" class="form-control input-secondary" placeholder="Precio"
                    v-model="agregar_producto.precio_real">
                </div>

                <!-- INPUTS PARA PRODUCTO SIN OC -->
                <div v-if="agregar_producto.producto && (agregar_producto.producto.is_comodin == false && sinOC == true)" class="form-group">
                  <label class="form-label">Descripción de Producto sin OC</label>
                  <textarea v-model="agregar_producto.descripcion" class="form-control input-secondary"
                    placeholder="Descripción"
                    :class="{ 'is-invalid': agregar_producto.errors && agregar_producto.errors.descripcion }">
                  </textarea>
                  <small v-if="agregar_producto.errors && agregar_producto.errors.descripcion" class="text-danger">
                    {{ agregar_producto.errors.descripcion[0] }}
                  </small>
                  <label class="mt-2">Precio Línea Total</label>
                  <input type="number" class="form-control input-secondary" placeholder="Precio"
                    v-model="agregar_producto.precio_real">
                </div>

                
                <!-- MOTIVOS (Mal Estado, Corta Fecha Venc., Faltante Transp., Sobre Stock, Promocional, etc.) PARA PRODUCTOS CON OC -->
                <div v-if="agregar_producto.producto && (agregar_producto.producto.is_comodin == false && sinOC == false)"
                  class="form-group motivos-section">
                  <label class="form-label">Motivos (Mal Estado, Corta Fecha, etc.)</label>

                  <div class="motivo-add-row">
                    <select v-model="motivoSeleccionado" class="form-control custom-select motivo-select">
                      <option :value="null" disabled>Seleccione motivo</option>
                      <option v-for="motivo in motivosCatalogoDisponibles" :key="motivo.value" :value="motivo.value">
                        {{ motivo.label }}
                      </option>
                    </select>
                    <input v-model="motivoCantidadInput" type="number" inputmode="numeric" min="1"
                      class="form-control text-center motivo-cantidad" placeholder="Cant." />
                    <button type="button" class="btn btn-dark motivo-add-btn" @click="agregarMotivo">
                      <i class="fas fa-plus"></i>
                    </button>
                  </div>

                  <small v-if="agregar_producto.errors && agregar_producto.errors.motivos" class="text-danger d-block mt-2">
                    <i class="fas fa-exclamation-circle mr-1"></i>
                    Verifique las cantidades de los motivos ingresados.
                  </small>

                  <ul v-if="agregar_producto.motivos.length > 0" class="list-group motivo-list mt-2">
                    <li v-for="(item, idx) in agregar_producto.motivos" :key="item.motivo"
                      class="list-group-item d-flex justify-content-between align-items-center py-2">
                      <span>{{ motivoLabel(item.motivo) }}</span>
                      <span class="d-flex align-items-center">
                        <strong class="mr-3">{{ item.cantidad }}</strong>
                        <button type="button" class="btn btn-sm btn-outline-danger motivo-remove-btn"
                          @click="quitarMotivo(idx)">
                          <i class="fas fa-times"></i>
                        </button>
                      </span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between bg-light font-weight-bold py-2">
                      <span>Total</span>
                      <span>{{ totalMotivos }}</span>
                    </li>
                  </ul>
                </div>



              </div>
              <form class="p-2" @submit="agregarProducto">
                <!-- Tarima Field -->
                <div class="form-group">
                  <input v-model="agregar_producto.tarima" class="form-control input-secondary text-center"
                    placeholder="Tarima" type="number"
                    :class="{ 'is-invalid': agregar_producto.errors && agregar_producto.errors.tarima }" step="1"
                    @keydown.enter="agregarProducto" />
                  <small v-if="agregar_producto.errors && agregar_producto.errors.tarima" class="text-danger">
                    {{ agregar_producto.errors.tarima[0] }}
                  </small>
                </div>
                <div class="modal-footer px-0">
                  <button class="btn btn-block btn-success rounded-pill" type="submit">
                    Agregar Producto
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ProductosService from "@/services/catalogos/ProductosService";
import ProductosTiendaService from "@/services/catalogos/ProductosTiendaService";
import ProductoLoteSelectComponent from "@/components/commons/ProductoLoteSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import OrdenCompraService from "../../../services/compras/OrdenCompraService";
import UnidadMedidaService from "@/services/catalogos/UnidadMedidaService";
import moment from 'moment'
import OCIndexedDBService from "@/services/wms/OCIndexedDBService";
import RecepcionService from "@/services/wms/RecepcionService";
import RecepcionFacturaEService from "@/services/wms/RecepcionFacturaEService";

export default {
  name: "RecepcionAgregarProductoDetalle",
  components: {
    ProductoLoteSelectComponent,
  },
  data() {
    return {
      currentStep: "",
      cb: "",
      barra: "",
      NORMAL: "A",
      NO_RECEPCIONADO: "X",
      NO_SOLICITADO: "N",
      SOLICITAR_AUTORIZACION: "S",
      BONIFICACION: "B",
      PROMOCION: "P",

      filter: {
        id: 0,
        cantidad: 0,
        mal_estado: 0,
        producto: "",
        lote: "",
      },
      showModal: false,
      lotes: {
        lote: '',
        fecha_produccion: null,
        fecha_vencimiento: null,
      },
      detalle_factura: "",

      agregar_producto: {
        producto: null,
        cantidad: 0,
        estado: "A",
        // Lista dinámica de motivos (Mal Estado, Corta Fecha Venc., Faltante Transporte,
        // Sobre Stock, Promocional, etc.), cada uno con su cantidad. El catálogo de motivos
        // válidos se carga desde el backend (ver motivosCatalogo) en vez de tener un input fijo
        // por motivo, para poder agregar nuevos motivos sin tocar este componente.
        motivos: [],
        tarima: "",
        unidad_recepcion: null,
        precio_real: 0,
        precio_unitario: 0,
        errors: {
          producto: null,
          cantidad: null,
          estado: "A",
          motivos: null,
          descripcion: "",
          unidad_recepcion: null,
        },
      },
      motivosCatalogo: [],
      motivoSeleccionado: null,
      motivoCantidadInput: '',
      detalle_x_lotes_tienda: [],
      isRegistrarLote: false,
      tienda: "",
      resultados: [],
      orden_compra: [],
      orden_compra_info: [],
      reception_cantidad: 0,
      selectedOrdenIndex: null,
      cantidadInput: '0',
      cantidadError: false,
      unidades_medida_catalogo: [],
      
      // Estado que valida si el producto existe o no en OC
      sinOC: false,
      detalle_oc_id: null,
      idbDetails: [],
      unidadMedidaSelected: null,
      orden_compra_detalles: [],
      availableDynamicUoMs: [],
      selectedDynamicUoMIndex: 0,
      ordenCompraDetailSelected: {
        orden_compra_d: {
          pendiente: 0,
        },
      }
    };
  },



  
  watch: {

    selectedDynamicUoMIndex: {
      handler(newVal) {
        console.log("select Dynamic UoM: ", newVal);
        const selected = this.availableDynamicUoMs.find((item) => item.id === newVal);
        if (selected) {
          this.ordenCompraDetailSelected = selected;
          // Seteamos el estado automáticamente basado en el tipo de la línea (A=Normal, B=Boni, P=Promo)
          if (selected.orden_compra_d && selected.orden_compra_d.tipo) {
            this.agregar_producto.estado = selected.orden_compra_d.tipo;
          }
        }
        console.log("ordenCompraDetailSelected: ", this.ordenCompraDetailSelected);
      },
    },

    "agregar_producto.producto": {
      handler(newVal) {
        //console.log("newVAL FORMULARIO: ",newVal);
        if (newVal && newVal.sku) {
          this.filter.producto = newVal.sku;
        }
      },
      immediate: true,
    },
    "agregar_producto.cantidad": {
      handler(val) {
        if (val !== null && val !== undefined) {
          this.cantidadInput = val.toString();
        }
      },
      immediate: true,
    },
    currentStep: {
      handler() {
        this.saveToLocalStorage();
      },
    },
    agregar_producto: {
      handler() {
        this.saveToLocalStorage();
      },
      deep: true,
    },
    detalle_x_lotes_tienda: {
      handler() {
        this.saveToLocalStorage();
      },
      deep: true,
    },
    lotes: {
      handler() {
        this.saveToLocalStorage();
      },
      deep: true,
    },
    filter: {
      handler() {
        this.saveToLocalStorage();
      },
      deep: true,
    },
    routeCurrent: {
      handler() {
        this.saveToLocalStorage();
      },
      deep: true,
    },
    "agregar_producto.precio_real": {
      handler(val) {
        if (this.sinOC || (this.agregar_producto.producto && this.agregar_producto.producto.is_comodin)) {
          const cantidad = parseFloat(this.agregar_producto.cantidad);
          const total = parseFloat(val);
          if (cantidad > 0) {
            this.agregar_producto.precio_unitario = total / cantidad;
          } else {
            this.agregar_producto.precio_unitario = 0;
          }
        }
      }
    },
    "agregar_producto.cantidad": {
      handler(val) {
        if (val !== null && val !== undefined) {
          this.cantidadInput = val.toString();
        }
        if (this.sinOC || (this.agregar_producto.producto && this.agregar_producto.producto.is_comodin)) {
          const cantidad = parseFloat(val);
          const total = parseFloat(this.agregar_producto.precio_real);
          if (cantidad > 0) {
            this.agregar_producto.precio_unitario = total / cantidad;
          } else {
            this.agregar_producto.precio_unitario = 0;
          }
        }
      },
      immediate: true,
    },
  },




  computed: {
    /**
     * Calcula la cantidad total pendiente para el estado Y la unidad de medida (UoM) seleccionados.
     * Si se selecciona "Unidad - Auth" (ID 69), suma todos los pendientes en unidad base para el estado.
     * Si se selecciona una UoM estándar, filtra todos los items que coinciden (estado y UoM),
     * suma sus pendientes en unidad base y luego divide por el factor de la UoM.
     * @returns {number|string} La cantidad pendiente calculada en la UoM seleccionada, o 'sinOC'/'0'.
     */
    pendienteEnUM() {
      const selectedUoMId = Number(this.selectedOrdenIndex);
      const currentStatus = this.agregar_producto.estado;

      if (!Array.isArray(this.orden_compra_info)) return 'sinOC';

      // Usar ID dinamico
      if (selectedUoMId === this.unidadBaseId) {
        const itemsForStatus = this.orden_compra_info.filter(item => item && item.tipo === currentStatus);

        if (itemsForStatus.length === 0) return 0;
        return itemsForStatus.reduce((acc, it) => acc + (Number(it.pendiente) || 0), 0);
      }
      if (selectedUoMId === 0) {
        return 0; // Comodín no tiene pendiente
      }
      const matchingItems = this.orden_compra_info.filter(i =>
        i.tipo === currentStatus &&
        i.unidad_medida &&
        i.unidad_medida.id === selectedUoMId
      );

      if (matchingItems.length === 0) {
        return 0;
      }

      const factor = (matchingItems[0].unidad_medida && Number(matchingItems[0].unidad_medida.cantidad_unidades))
        ? Number(matchingItems[0].unidad_medida.cantidad_unidades)
        : 1;
      const pendienteBaseTotal = matchingItems.reduce((acc, item) => {
        return acc + (Number(item.pendiente) || 0);
      }, 0);
      return pendienteBaseTotal / factor;
    },
    /**
     * Establece el estado (tipo) seleccionado para el producto.
     * @param {string} status - El tipo de estado (ej. 'A', 'B', 'P').
     */
    estadoEnOC() {
      const estadoMap = {
        A: 'normal',
        B: 'boni',
        P: 'promo'
      };
      return estadoMap[this.agregar_producto.estado] || 'Sin OC';
    },


    pendienteEnDynamicUoM() {
      return Number(this.ordenCompraDetailSelected.orden_compra_d.cantidad_um);
    },

    pendienteActualizadoOCD() {
      if (this.ordenCompraDetailSelected && this.ordenCompraDetailSelected.orden_compra_d) {
        if (Array.isArray(this.orden_compra_info)) {
          const matchedInfo = this.orden_compra_info.find(info => info.id === this.ordenCompraDetailSelected.orden_compra_d.id);
          if (matchedInfo && matchedInfo.pendiente !== undefined) {
            return Number(matchedInfo.pendiente);
          }
        }
        return Number(this.ordenCompraDetailSelected.orden_compra_d.pendiente || 0);
      }
      return 0;
    },

    isComplete() {
      // return (this.pendienteEnUM - this.agregar_producto.cantidad) === 0; // Legacy
      return (this.pendienteEnDynamicUoM - this.agregar_producto.cantidad) === 0;
    },

    /**
     * Suma de las cantidades de todos los motivos agregados (Mal Estado, Corta Fecha, etc.)
     */
    totalMotivos() {
      if (!Array.isArray(this.agregar_producto.motivos)) return 0;
      return this.agregar_producto.motivos.reduce((acc, item) => acc + (Number(item.cantidad) || 0), 0);
    },

    /**
     * Motivos del catálogo que aún no han sido agregados a la lista, para no ofrecer duplicados en el selector.
     */
    motivosCatalogoDisponibles() {
      if (!Array.isArray(this.motivosCatalogo)) return [];
      const usados = new Set(this.agregar_producto.motivos.map(item => item.motivo));
      return this.motivosCatalogo.filter(m => !usados.has(m.value));
    },
    /**
     * Determina la clase CSS para el semáforo visual (rojo/verde)
     * basado en la cantidad ingresada vs. la pendiente.
     */
    semaphoreClass() {
      return this.isComplete ? 'semaphore-green' : 'semaphore-red';
    },

    selectedUnidadNombre() {
      if (Array.isArray(this.orden_compra_info) && this.orden_compra_info.length > 0) {
        if (this.selectedOrdenIndex === 69 || this.selectedOrdenIndex === null) {
          return this.orden_compra && this.orden_compra.unidad_medida ? this.orden_compra.unidad_medida.nombre : '';
        }
        const id = Number(this.selectedOrdenIndex);
        const item = this.orden_compra_info.find(i => i && i.unidad_medida && i.unidad_medida.id === id);
        return item && item.unidad_medida ? item.unidad_medida.nombre : (this.orden_compra && this.orden_compra.unidad_medida ? this.orden_compra.unidad_medida.nombre : '');
      }
      return this.orden_compra && this.orden_compra.unidad_medida ? this.orden_compra.unidad_medida.nombre : '';
    },
    /**
     * Extrae los tipos de estado únicos (ej. 'A', 'B', 'P') de 'orden_compra_info'.
     * Se usa para renderizar los botones de estado (Normal, Boni, Promo).
     * @returns {Array<string>} Un array de strings con los tipos de estado únicos.
     */
    availableStatuses() {
      if (!Array.isArray(this.orden_compra_info) || this.orden_compra_info.length === 0) {
        return [{ tipo: 'A', nombre: 'Normal' }];
      }

      const statusMap = {
        'A': 'Normal',
        'B': 'Boni',
        'P': 'Promo'
      };

      const uniqueTipos = [...new Set(this.orden_compra_info.map(item => item.tipo).filter(Boolean))].sort();

      if (uniqueTipos.length === 0) {
        return [{ tipo: 'A', nombre: 'Normal' }];
      }

      return uniqueTipos.map(tipo => ({
        tipo: tipo,
        nombre: statusMap[tipo] || `Tipo ${tipo}`
      }));
    },
    
    /**
     * Genera la lista de unidades de medida (UoM) disponibles para el estado (tipo) seleccionado.
     * Filtra las UoM de 'orden_compra_info' basadas en 'agregar_producto.estado'.
     * De-duplica las UoM para que cada 'unidad_medida.id' aparezca solo una vez.
     * Maneja la lógica para "Comodín" (ID 0) y "Unidad - Necesita autorización" (ID 69).
     * @returns {Array<Object>} Un array de objetos (de 'orden_compra_info') que representan las UoM únicas.
     */
    availableUoMs() {
      let uoms = [];
      const isComodin = this.agregar_producto.producto && this.agregar_producto.producto.is_comodin === true && this.sinOC === false;
      const sinOC = this.agregar_producto.producto && this.sinOC === true;
      if (isComodin || sinOC) {
        uoms.push({
          unidad_medida: { id: this.unidadBaseId, nombre: 'Unidad', cantidad_unidades: 1 },
          pendiente: 0
        });
        return uoms;
      }
      if (Array.isArray(this.orden_compra_info)) {
        const itemsForStatus = this.orden_compra_info.filter(item =>
          item.tipo === this.agregar_producto.estado && item.unidad_medida
        );
        const uomMap = new Map();
        itemsForStatus.forEach(item => {
          if (!uomMap.has(item.unidad_medida.id)) {
            uomMap.set(item.unidad_medida.id, item);
          }
        });
        uoms = Array.from(uomMap.values());
      }
      // Usar ID dinamico en lugar de 69 hardcodeado
      const targetId = this.unidadBaseId;
      const hasUnidadAuth = uoms.some(item => item.unidad_medida.id === targetId);
      if (!hasUnidadAuth) {
        uoms.push({
          unidad_medida: { id: targetId, nombre: this.unidadBaseNombre, cantidad_unidades: 1 },
          pendiente: 0
        });
      }
      return uoms;
    },


    /**
     * Obtiene una cadena de texto con los números de orden de compra (OC) únicos
     * que corresponden al estado (tipo) actualmente seleccionado.
     * Se usa para mostrar el/los número(s) de OC en el encabezado.
     * @returns {string} Un string con los números de OC, separados por comas (ej. "70475, 70474") o "Sin OC".
     */
    numerosOrdenCompraMostrados() {
      const currentStatus = this.agregar_producto.estado;

      if (!Array.isArray(this.orden_compra_info) || this.orden_compra_info.length === 0) {
        return 'Sin OC';
      }

      if (!currentStatus) {
        return this.orden_compra && this.orden_compra.numero_orden ? this.orden_compra.numero_orden : 'Sin OC';
      }

      const itemsForStatus = this.orden_compra_info.filter(item => item && item.tipo === currentStatus);
      if (itemsForStatus.length === 0) {
        return this.orden_compra && this.orden_compra.numero_orden ? this.orden_compra.numero_orden : 'Sin OC';
      }

      const orderNumbers = itemsForStatus.map(item => item.numero_orden);
      const uniqueOrderNumbers = [...new Set(orderNumbers)];
      return uniqueOrderNumbers.join(', ');
    },
    

    // Busqueda dinamica de la unidad base por nombre
    unidadBaseObj() {
        if (!this.unidades_medida_catalogo || this.unidades_medida_catalogo.length === 0) return null;
        // Busca "UNIDAD" o "Unidad" ignorando case y espacios
        return this.unidades_medida_catalogo.find(u => u.nombre && u.nombre.trim().toUpperCase() === 'UNIDAD');
    },
    unidadBaseId() {
        return this.unidadBaseObj ? this.unidadBaseObj.id : 69; // 69 Fallback si no carga
    },
    unidadBaseNombre() {
        // Si se encuentra la real, usar su nombre real. Si no, usar texto legacy para no romper UI
        return this.unidadBaseObj ? this.unidadBaseObj.nombre : 'Unidad - Necesita autorización';
    },

    availableUoMsOnIDBase() {
      if (!Array.isArray(this.idbDetails) || !this.agregar_producto.producto) return [];
      
      const sku = this.agregar_producto.producto.sku;
      // Filtrar por SKU y de-duplicar por ID de unidad de medida
      const filtered = this.idbDetails.filter(item => item.sku === sku && item.unidad_medida);
      
      const uomMap = new Map();
      filtered.forEach(item => {
        if (item.unidad_medida && !uomMap.has(item.unidad_medida.id)) {
          uomMap.set(item.unidad_medida.id, {
            unidad_medida: item.unidad_medida,
            detalle_oc_id: item.detalle_oc_id
          });
        }
      });
      
      return Array.from(uomMap.values());
    },
  },

  /**
   * Hook del ciclo de vida de Vue. Se ejecuta cuando el componente está montado.
   * Llama a 'loadFromLocalStorage' y 'loadProduct' para inicializar el estado.
   */
  mounted() {
    this.loadFromLocalStorage();
    this.loadProduct();
    this.loadOCDetails();
    this.cantidadInput = this.agregar_producto.cantidad.toString();
    window.addEventListener('beforeunload', this.saveToLocalStorage);

    // Cargar catalogo de unidades de medida para buscar "UNIDAD" dinamicamente
    UnidadMedidaService.fetch({ limit: 1000 }).then(response => {
        if (response.data) {
            this.unidades_medida_catalogo = response.data.results ? response.data.results : response.data;
        }
    }).catch(error => {
        console.error("Error cargando unidades de medida:", error);
    });

    this.cargarMotivosMalEstado();
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.saveToLocalStorage);
  },

  methods: {
    /**
     * Evaluador seguro para expresiones matemáticas simples con decimales y multiplicación.
     * Solo permite números decimales y el operador '*'. Previene inyecciones y errores.
     * @param {string} expr - La expresión a evaluar (ej. "5.5*2").
     * @returns {number|null} El resultado numérico o null si inválido.
     */
    evaluateExpression(expr) {
      expr = expr.trim();
      if (!expr) return 0;
      // Solo permitir dígitos, puntos decimales, espacios y '*'
      if (!/^[\d\s\*\.]+$/.test(expr)) return null;
      const parts = expr.split('*').map(p => p.trim());
      if (parts.some(p => p === '')) return null; // Partes vacías
      let result = 1;
      for (const part of parts) {
        const num = parseFloat(part);
        if (isNaN(num)) return null;
        result *= num;
      }
      return result;
    },
    /**
     * Maneja el evento @blur del campo cantidad, evaluando la expresión y actualizando el estado.
     * Solo se ejecuta al perder el foco para evitar lags en dispositivos móviles.
     */
    onCantidadBlur() {
      const val = this.evaluateExpression(this.cantidadInput);
      if (val !== null && val >= 0 && val <= 99999) {
        this.agregar_producto.cantidad = Math.round(val);
        this.cantidadError = false;
        this.agregar_producto.errors.cantidad = null;
      } else {
        this.cantidadError = true;
        this.agregar_producto.errors.cantidad = 'Expresión inválida o fuera de rango (1-9999)';
        // No actualizar cantidad si es inválida, mantener el valor anterior
      }
    },
    /**
     * Inserta el carácter '*' en la posición actual del cursor en el input de cantidad.
     */
    insertMultiply() {
      const input = this.$refs.cantidadInputRef;
      const start = input.selectionStart;
      const end = input.selectionEnd;
      this.cantidadInput = this.cantidadInput.substring(0, start) + '*' + this.cantidadInput.substring(end);
      this.$nextTick(() => {
        input.focus();
        input.setSelectionRange(start + 1, start + 1);
      });
    },


    /**
     * Carga los datos del producto y la orden de compra desde los parámetros de la ruta (Vue Router).
     * Asegura que 'orden_compra_info' sea siempre un array.
     * También inicializa 'agregar_producto.producto'.
     */
    async loadProduct() {
      // Mantenemos referencia al contexto 'this'
      let self = this;

      // Limpiamos el estado actual para asegurar una carga limpia desde cero
      self.refreshDefault();

      // Obtenemos el objeto 'current' de los parámetros de la ruta
      const routeCurrentFromParams = (this.$route && this.$route.params && this.$route.params.current) ? this.$route.params.current : null;
      
      // Si recibimos data nueva por ruta, la usamos. Si no (ej. refresh), mantenemos lo que cargó loadFromLocalStorage
      if (routeCurrentFromParams) {
        self.routeCurrent = routeCurrentFromParams;
      }
      
      // Variable local para acceso seguro durante este método
      const activeRoute = self.routeCurrent;

      // Guardamos el SKU anterior para comparar si el producto cambió
      const previousCb = self.cb;
      
      // Asignamos el detalle de la orden de compra desde la ruta o inicializamos como arreglo vacío
      self.orden_compra_info = activeRoute && activeRoute.orden_compra ? activeRoute.orden_compra : (self.orden_compra_info || []);

      if (self.orden_compra_info && self.orden_compra_info.length > 0) {
        console.log("CON OC", self.orden_compra_info);
        this.sinOC = false;
      } else {
        console.log("SIN OC");
        this.sinOC = true;
      }

      // Creamos una copia profunda del producto para evitar mutar el objeto original de la ruta
      self.agregar_producto.producto = activeRoute && activeRoute.producto
        ? JSON.parse(JSON.stringify(activeRoute.producto))
        : (self.agregar_producto.producto);
      
      // Asignamos la tienda desde la ruta
      self.tienda = activeRoute && activeRoute.tienda ? activeRoute.tienda : (self.tienda || "");
      
      // Aseguramos que el paso actual esté inicializado y lo reseteamos para una carga limpia
      self.currentStep = self.currentStep || "";
      self.currentStep = ""
      
      // Guardamos la referencia al ID del encabezado de la orden de compra
      self.agregar_producto.orden_compra = activeRoute ? activeRoute.orden_compra_e : null;

      // Si el SKU cambió respecto al anterior, reseteamos todos los contadores de cantidad y estados
      if (activeRoute && activeRoute.sku && activeRoute.sku !== previousCb) {
        this.agregar_producto.cantidad = 0;
        this.agregar_producto.motivos = [];
        this.detalle_x_lotes_tienda = [];
      }

      // Validamos que 'orden_compra_info' sea un arreglo; si no, lo convertimos o vaciamos
      if (!Array.isArray(self.orden_compra_info)) {
        self.orden_compra_info = self.orden_compra_info ? [self.orden_compra_info] : [];
        console.log("self.orden_compra_info", self.orden_compra_info);

        // Ejecutamos cambios de estado iniciales si no es un arreglo
        this.onStatusChange(self.agregar_producto.estado);
      }

      // Inicializamos la cantidad esperada de la recepción según la unidad de medida
      this.reception_cantidad = (this.orden_compra && this.orden_compra.cantidad_um) ? this.orden_compra.cantidad_um : 0;

      // Si el producto tiene SKU, inicializamos la lógica de registro de lotes/fechas
      if (this.agregar_producto.producto && this.agregar_producto.producto.sku) {
        this.toggleLote({ preventDefault: () => { }, stopPropagation: () => { } });
        
        if (this.sinOC) {
          // Esperamos a que las unidades carguen ANTES de seleccionar la UoM inicial
          await this.fetchProductoUnidades(this.agregar_producto.producto.sku);
        }
      }

      // Usamos nextTick para que Vue procese el nuevo orden_compra_info y luego seteamos la UoM
      this.$nextTick(() => {
        this.onStatusChange(this.agregar_producto.estado);
      });

      // Actualizamos el SKU de control (cb) al final de la carga exitosa
      self.cb = activeRoute && activeRoute.sku ? activeRoute.sku : self.cb;
    },



    obtenerEstado(tipo=null){
      if (tipo === 'A'){return "Normal"}
      if (tipo === 'B'){return "Boni"}
      if (tipo === 'P'){return "Promocional"}
      return ""
    },
     

    /** 
     * Carga los detalles de la orden de compra desde IndexedDB 
     */
    async loadOCDetails() {
        let recepcionId = null;     
        const storedId = localStorage.getItem("id_recepcion");
        if (storedId) {
          recepcionId = JSON.parse(storedId);
          console.log("Recepcion ID recuperado desde LocalStorage:", recepcionId);
        } else {
          recepcionId = this.routeCurrent ? this.routeCurrent.id : null;
        }
        if (recepcionId != null) {
          console.log("Recepcion ID: ", recepcionId);
          try {
            const details = await OCIndexedDBService.getDetails(recepcionId);
            if (details) {
              this.idbDetails = details;
              console.log("Detalles de IndexedDB cargados en el componente:", details.length);
              const sku = this.agregar_producto.producto.sku;
              const matchedDetails = details.filter(item => item.sku == sku);
              if (matchedDetails.length > 0) {
                const ocIds = [...new Set(matchedDetails.map(item => item.padre_oc_id).filter(id => id != null))];
                if (ocIds.length > 0) {
                  console.log("Refrescando detalles de OC desde API para SKU:", sku, "OCs:", ocIds);
                  const response = await RecepcionService.obtenerDetallesOrdenCompraPorProducto(recepcionId, {
                    sku: sku,
                    oc_id_group: ocIds
                  });
                  if (response.data && response.data.length > 0) {
                    this.orden_compra_detalles = response.data;
                    this.availableDynamicUoMs = this.orden_compra_detalles
                      .filter(ocd_item => ocd_item.estado === 'A')
                      .map((ocd_item) => ({
                        id: ocd_item.id, // Usamos el ID del detalle (UUID) como identificador único
                        nombre: ocd_item.unidad_medida.nombre,
                        estatus: ocd_item.unidad_medida.estatus,
                        numero_orden: ocd_item.numero_orden, // Ahora viene del backend
                        orden_compra_d: ocd_item
                      }));
                    this.selectedDynamicUoMIndex = this.availableDynamicUoMs[0].id;
                    console.log("OrdenCompraD: ", this.orden_compra_detalles);
                    console.log("availableDynamicUoMs: ", this.availableDynamicUoMs);
                    // Sincronizamos con IndexedDB de forma segura
                    try {
                      const allDetails = await RecepcionService.obtenerDetalleOrdenCompra(recepcionId);
                      if (allDetails.data) {
                        await OCIndexedDBService.mapAndSaveRawDetails(recepcionId, allDetails.data);
                        console.log("IDB Sincronizado en el detalle");
                      }
                    } catch (e) {
                      console.error("Error sincronizando IDB:", e);
                    }
                  }
                }
              }
            }
          } catch (err) {
            console.error("Error cargando/refrescando detalles desde IDB/API:", err);
          }
        }
    },






    /**
     * Método observador (watcher) que se dispara cuando 'agregar_producto.estado' cambia.
     * Resetea la unidad de medida seleccionada ('selectedOrdenIndex') a 'null'.
     * @param {string} newStatus - El nuevo estado seleccionado. (No se usa directamente, pero es parte del watcher).
     */
    onStatusChange(newStatus) {
      this.agregar_producto.estado = newStatus;

      // Forzar actualización de UoM
      // Esperamos al $nextTick para asegurar que 'availableUoMs' se haya recalculado
      this.$nextTick(() => {
        const firstAvailableUoM = this.availableUoMs[0];

        if (firstAvailableUoM) {
          const newUoMId = firstAvailableUoM.unidad_medida.id;
          // Seteamos el nuevo índice y llamamos al método que actualiza la data
          this.selectedOrdenIndex = newUoMId;
          this.onOrdenCompraInfoSelect(newUoMId);
        } else {
          // Fallback (aunque con la nueva lógica, esto casi nunca debería pasar)
          const fallbackId = (this.agregar_producto.producto && this.agregar_producto.producto.is_comodin) ? 0 : 69;
          this.selectedOrdenIndex = fallbackId;
          this.onOrdenCompraInfoSelect(fallbackId);
        }
      });
    },

    functionNew(val) {
      const selectedUoMId = Number(val);
      this.selectedOrdenIndex = selectedUoMId;
      this.onOrdenCompraInfoSelect(selectedUoMId);
    },

    /**
     * Método observador (watcher) que se dispara cuando 'selectedOrdenIndex' (el v-model del select de UoM) cambia.
     * Actualiza 'agregar_producto.unidad_medida' y 'agregar_producto.producto'
     * basándose en el item seleccionado de 'availableUoMs'.
     * @param {number|string} newIndex - El ID de la unidad de medida seleccionada (ej. 12, 69, 0).
     */
    onOrdenCompraInfoSelect(value) {
      const selectedUoMId = Number(value);
      this.selectedOrdenIndex = selectedUoMId;

      if (selectedUoMId === 0) { // Comodin 'Unidad'
        this.agregar_producto.unidad_recepcion = { id: 0, nombre: 'Unidad', cantidad_unidades: 1 };
      } else if (selectedUoMId === 69) { // 'Unidad - Necesita autorización'
        this.agregar_producto.unidad_recepcion = { id: 69, nombre: 'Unidad - Necesita autorización', cantidad_unidades: 1 };
      } else {
        // Encontrar la UoM en la lista filtrada (availableUoMs)
        const found = this.availableUoMs.find(i => i.unidad_medida && i.unidad_medida.id === selectedUoMId);

        if (found && found.unidad_medida) {
          this.agregar_producto.unidad_recepcion = found.unidad_medida;
        } else {
          // Fallback por si algo falla
          this.agregar_producto.unidad_recepcion = { id: selectedUoMId, nombre: 'Unidad Desconocida', cantidad_unidades: 1 };
        }
      }
    },

    onOrdenCompraSelectDynamicUoM(value) {
      console.log("VALOR DYNAMICAL: ", value);
    },


    /**
     * Carga el catálogo de motivos (Mal Estado, Corta Fecha Venc., Faltante Transporte,
     * Sobre Stock, Promocional, etc.) desde el backend, en vez de tenerlos hardcodeados aquí.
     */
    async cargarMotivosMalEstado() {
      try {
        const response = await RecepcionFacturaEService.getMotivosMalEstado();
        this.motivosCatalogo = response.data || [];
      } catch (error) {
        console.error("Error cargando catálogo de motivos:", error);
      }
    },

    /**
     * Retorna la etiqueta legible (ej. "Mal Estado") para un código de motivo (ej. "M").
     */
    motivoLabel(codigo) {
      const found = this.motivosCatalogo.find(m => m.value === codigo);
      return found ? found.label : codigo;
    },

    /**
     * Agrega (o suma, si el motivo ya estaba en la lista) la cantidad capturada en el
     * selector/input de "agregar motivo" a agregar_producto.motivos.
     */
    agregarMotivo() {
      const motivo = this.motivoSeleccionado;
      const cantidad = parseInt(this.motivoCantidadInput, 10);

      if (!motivo) {
        Notifications.toast.error("Agregar Motivo", "Seleccione un motivo.");
        return;
      }
      if (!cantidad || cantidad <= 0) {
        Notifications.toast.error("Agregar Motivo", "Ingrese una cantidad mayor a 0.");
        return;
      }

      const existente = this.agregar_producto.motivos.find(item => item.motivo === motivo);
      if (existente) {
        existente.cantidad += cantidad;
      } else {
        this.agregar_producto.motivos.push({ motivo, cantidad });
      }

      this.motivoSeleccionado = null;
      this.motivoCantidadInput = '';
    },

    /**
     * Quita un motivo de la lista de agregar_producto.motivos.
     */
    quitarMotivo(index) {
      this.agregar_producto.motivos.splice(index, 1);
    },

    async fetchProductoUnidades(sku) {
      // Usar servicio de UnidadMedida filtrando por producto para obtener los objetos completos directamente
      try {
        const response = await UnidadMedidaService.fetch({ producto: sku, limit: 1000 });
        const data = response.data.results ? response.data.results : response.data;
        if (Array.isArray(data)) {
          this.orden_compra_info = data.map(um => ({
            unidad_medida: um, // El servicio ya devuelve el objeto completo {id, nombre, ...}
            tipo: 'A',
            pendiente: 0
          }));
          console.log("Unidades cargadas:", this.orden_compra_info);
        }
      } catch (error) {
        console.error("Error cargando unidades del producto:", error);
      }
    },







    async agregarProducto(e) {
      let self = this;
      e.preventDefault();

      if (self.sinOC) {
        if (!self.agregar_producto.precio_real || parseFloat(self.agregar_producto.precio_real) <= 0) {
          Notifications.alert.error(
            "Precio Obligatorio",
            "Debe ingresar el Precio Línea Total mayor a 0 para los productos sin orden de compra."
          );
          return;
        }
      }

      const isComodinOrSinOC = self.sinOC || (self.agregar_producto.producto && self.agregar_producto.producto.is_comodin);

      // Si es comodin o sin OC, ordenCompraDetailSelected no estará definido, usamos fallbacks
      const matchedDetail = self.idbDetails.find(item => item.sku === self.agregar_producto.producto.sku);
      const ordenCompraEId = isComodinOrSinOC
        ? (matchedDetail ? matchedDetail.padre_oc_id : null)
        : (self.ordenCompraDetailSelected && self.ordenCompraDetailSelected.orden_compra_d
            ? self.ordenCompraDetailSelected.orden_compra_d.orden_compra_e
            : null);

      const productoId = self.agregar_producto.producto.sku || self.agregar_producto.producto.id;
      const unidadId = isComodinOrSinOC
        ? self.selectedOrdenIndex
        : (self.ordenCompraDetailSelected && self.ordenCompraDetailSelected.orden_compra_d && self.ordenCompraDetailSelected.orden_compra_d.unidad_medida
            ? self.ordenCompraDetailSelected.orden_compra_d.unidad_medida.id
            : null);

      const productosPayload = { ...self.agregar_producto };

      productosPayload.producto = productoId;
      productosPayload.orden_compra = ordenCompraEId;
      productosPayload.unidad_recepcion = unidadId;

      // Asegurar que para sinOC o comodin, el precio_unitario sea el calculado
      if (this.sinOC || (self.agregar_producto.producto && self.agregar_producto.producto.is_comodin)) {
        const cantidad = parseFloat(self.agregar_producto.cantidad);
        const total = parseFloat(self.agregar_producto.precio_real);
        productosPayload.precio_unitario = cantidad > 0 ? (total / cantidad) : 0;
      }
      const params = {
        productos: productosPayload,
        loteTienda: [...self.detalle_x_lotes_tienda],
      };
      params.loteTienda = params.loteTienda.map((lote) => {
        const { id, ...loteData } = lote;
        return loteData;
      });
      const facturaeId = this.$route.params.facturaeId;
      if (this.currentStep === 'crear_lote') {
        try {
          await this.guardarFechas(e);
        } catch (err) {
          return;
        }
      }

      DynamicService.postAction(
        "wms",
        "facturas",
        facturaeId,
        "agregar_detalle_factura",
        params
      )
        .then((res) => {
          if (res.data && res.data.warning) {
            Notifications.alert.error(
              "Sobre-recepción detectada",
              res.data.msg || "Se ha detectado una sobre-recepción. El excedente se marcó como 'No Solicitado'."
            );
          } else {
            Notifications.alert.success(
              "Agregar detalle",
              "Se ha guardado la Información."
            );
          }
          
          const storedId = localStorage.getItem("id_recepcion");
          if (storedId) {
            const recepcionId = JSON.parse(storedId);
            // Sincronización en segundo plano (asíncrona) de los detalles de OC.
            // Esto permite actualizar las cantidades de la base de datos local
            // sin hacer esperar a la UI para el $router.back()
            RecepcionService.obtenerDetalleOrdenCompra(recepcionId).then((resOC) => {
              if (resOC.data && resOC.data.length > 0) {
                OCIndexedDBService.mapAndSaveRawDetails(recepcionId, resOC.data).then(() => {
                  console.log("IDB Sincronizado en segundo plano tras agregar producto");
                }).catch((error) => {
                  console.error("Error al guardar en IDB:", error);
                });
              }
            }).catch((err) => {
              // Notificar al usuario si falla la sincronización en segundo plano
              console.error("Error actualizando cantidades pendientes:", err);
              // Como this.$router.back() ya ocurrió, podemos disparar un toast global
              Notifications.toast.error(
                "ADVERTENCIA DE SINCRONIZACIÓN",
                "Hubo un problema al actualizar las cantidades pendientes. Por favor, refresque la página si nota datos desactualizados."
              );
            });
          }
          // Retorno asíncrono e instantáneo para el usuario
          this.refreshDefault();
          this.agregar_producto.estado = "A";
          this.$router.back();
        })
        .catch((err) => {
          if (err.response.data.detail) {
            Notifications.alert.error("Agregar detalle", err.response.data.detail);
          }
          self.agregar_producto.errors = Object.assign(
            {},
            err.response.data
          );
        });


    },







    refreshDefault() {
      this.agregar_producto = {
        producto: null,
        cantidad: 0,
        estado: 'A',
        motivos: [],
        descripcion: "",
        tarima: "",
        unidad_recepcion: null,
        errors: {
          producto: null,
          cantidad: null,
          unidad_recepcion: null,
        },
      };
      this.cantidadInput = '0';
      this.cantidadError = false;
      this.motivoSeleccionado = null;
      this.motivoCantidadInput = '';
    },

    toggleLote(event) {
      event.preventDefault();
      event.stopPropagation();
      let self = this;

      // si no hay producto o sku, no intentar fetch
      if (!self.agregar_producto || !self.agregar_producto.producto || !self.agregar_producto.producto.sku) {
        self.isRegistrarLote = false;
        return;
      }
      ProductosTiendaService.fetch({
        producto: self.agregar_producto.producto.sku,
        tienda: self.tienda,
      }).then((response) => {
        self.isRegistrarLote = response.data.results[0].permitir_recepcion_con_lote;
      }).catch((err) => {
        self.isRegistrarLote = false;
      });

    },
    refreshFilter() {
      let self = this;
      self.filter.cantidad = 0;
      self.filter.mal_estado = 0;
    },
    async guardarFechas(e) {
      e.preventDefault();
      e.stopPropagation();

      let self = this;
      if (
        !self.lotes.lote ||
        !self.agregar_producto.producto.sku
      ) {
        Notifications.alert.error(
          "Registrar Lote",
          "Todos los campos de lote y producto son obligatorios."
        );
        throw new Error("Campos obligatorios faltantes para registrar lote.");
      }

      const payload = {
        id: `${self.agregar_producto.producto.sku}-${self.lotes.lote}`,
        codigo_lote: self.lotes.lote,
        fecha_fabricacion: self.lotes.fecha_produccion ? moment(self.lotes.fecha_produccion).format('DD/MM/YYYY') : null,
        fecha_vence: self.lotes.fecha_vencimiento ? moment(self.lotes.fecha_vencimiento).format('DD/MM/YYYY') : null,
        producto: self.agregar_producto.producto.sku,
      };

      try {
        const res = await DynamicService.postActionList(
          "cat",
          "producto-lote",
          "crear_nuevo_lote",
          payload
        );
        Notifications.toast.success(
          "Registrar Lote",
          "Lote registrado correctamente."
        );
      } catch (err) {
        let msg = "Error al registrar el lote.";

        if (err.response && err.response.data) {
          if (err.response.data.detail) {
            msg = err.response.data.detail;
          } else if (typeof err.response.data === "object") {
            const errorMessages = [];
            for (const field in err.response.data) {
              if (Array.isArray(err.response.data[field])) {
                errorMessages.push(...err.response.data[field]);
              } else {
                errorMessages.push(err.response.data[field]);
              }
            }
            if (errorMessages.length > 0) {
              msg = errorMessages.join(", ");
            }
          }
        }

        Notifications.alert.error("Registrar Lote", msg);
        throw err; // Rethrow to allow caller to handle
      }

      self.validarLote();
    },
    async validarLote() {
      let self = this;

      if (!self.agregar_producto || !self.agregar_producto.producto || !self.agregar_producto.producto.sku) {
        Notifications.toast.error('Validar Lote', 'Producto no disponible para validar lote');
        return;
      }
      if (!self.lotes || !self.lotes.lote) {
        Notifications.toast.error('Validar Lote', 'Ingrese un código de lote');
        return;
      }

      const sku = self.agregar_producto.producto.sku;
      const lote = self.lotes.lote;
      const lote_id = `${sku}-${lote}`;

      DynamicService.fetch('cat', 'producto-lote', { id: lote_id })
        .then((res) => {
          if (res && res.status === 200 && res.data && res.data.count > 0) {
            Notifications.alert.success('Lote de Producto', 'Lote de producto encontrado', 'Asignar');
            const found = res.data.results && res.data.results[0];
            if (found) {
              self.lotes.fecha_produccion = found.fecha_fabricacion
                ? moment(found.fecha_fabricacion).format('YYYY-MM-DD')
                : self.lotes.fecha_produccion;
              self.lotes.fecha_vencimiento = found.fecha_vence
                ? moment(found.fecha_vence).format('YYYY-MM-DD')
                : self.lotes.fecha_vencimiento;
            }
            this.currentStep = 'lote_creado';
          } else {
            Notifications.alert.error('Lote no registrado', 'Ingresa la fecha de producción y Vencimiento');
            this.currentStep = 'crear_lote'
          }
        })
        .catch((err) => {
        });
    },
    cancelarRegistroFechas() {
      // Reseteamos el estado para que pueda validar de nuevo
      this.currentStep = null;
      // Ya no hay 'showModal' que ocultar
    },
    seleccionar(item) {
      // setear el lote seleccionado en el filtro y limpiar la lista de resultados
      if (item && item.nombre) {
        this.filter.lote = item.nombre;
      }
      this.resultados = [];
    },
    refreshOrdenCompra() {
      let self = this;
      OrdenCompraService.getById(this.$route.params.id).then((response) => {
      });
    },


    /**
     * Guarda el estado actual de 'orden_compra_info', 'agregar_producto' y 'cantidad_ingresada'
     * en localStorage.
     */
    saveToLocalStorage() {
      const key = `recepcion-producto-${this.$route.params.facturaeId}-${this.$route.params.sku}`;

      const dataToSave = {
        cb: this.cb,
        orden_compra_info: this.orden_compra_info,
        tienda: this.tienda,
        routeCurrent: this.routeCurrent,
        producto: this.agregar_producto.producto,
        selectedOrdenIndex: this.selectedOrdenIndex,
        estado: this.agregar_producto.estado,
      };
      localStorage.setItem(key, JSON.stringify(dataToSave));
    },

    
    /**
     * Carga el estado del componente desde localStorage para persistir los datos
     * entre recargas de página. Restaura 'orden_compra_info' y otros datos de 'agregar_producto'.
     * Asegura que 'orden_compra_info' sea un array.
     */
    loadFromLocalStorage() {
      const key = `recepcion-producto-${this.$route.params.facturaeId}-${this.$route.params.sku}`;
      const savedData = localStorage.getItem(key);
      if (savedData) {
        try {
          const parsed = JSON.parse(savedData);

          const existingProduct = this.agregar_producto.producto;
          this.currentStep = parsed.currentStep || this.currentStep;
          this.lotes = { ...this.lotes, ...parsed.lotes };
          this.cb = parsed.cb !== undefined ? parsed.cb : this.cb;
          this.tienda = parsed.tienda !== undefined ? parsed.tienda : this.tienda;
          this.routeCurrent = parsed.routeCurrent !== undefined ? parsed.routeCurrent : this.routeCurrent;
          this.agregar_producto.producto = parsed.producto !== undefined ? parsed.producto : this.agregar_producto.producto;
          this.selectedOrdenIndex = parsed.selectedOrdenIndex !== undefined ? parsed.selectedOrdenIndex : this.selectedOrdenIndex;
          this.agregar_producto.estado = parsed.estado !== undefined ? parsed.estado : this.agregar_producto.estado;

          if (parsed.orden_compra_info !== undefined) {
            this.orden_compra_info = Array.isArray(parsed.orden_compra_info)
              ? parsed.orden_compra_info
              : (parsed.orden_compra_info ? [parsed.orden_compra_info] : []);

            // Asegurar opción 'Unidad' (id 69) presente
            const hasUnidad = this.orden_compra_info.some(item => item && item.unidad_medida && item.unidad_medida.id === 69);
            if (!hasUnidad) {
              this.orden_compra_info.push({
                unidad_medida: { id: 69, nombre: 'Unidad - Necesita autorización', cantidad_unidades: 1 },
                pendiente: 0,
              });
            }

            // Mostrar resumen usando el primer elemento cuando vienen varias opciones
            this.orden_compra = this.orden_compra_info.length > 0 ? this.orden_compra_info[0] : this.orden_compra;
          }
        } catch (e) {
          console.error('Error loading from localStorage', e);
        }
      }
    },
  },
};
</script>
<style scoped>
.form-section {
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 16px;
}

.form-label {
  font-size: 12px;
  font-weight: 500;
  color: #6c757d;
  margin-bottom: 4px;
  display: block;
}

.input-secondary {
  border: 1px solid #ced4da;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
}

.input-secondary:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.status-buttons {
  display: flex;
  border-radius: 25px;
  overflow: hidden;
  margin: 20px 0;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
}

.btn-status {
  flex: 1;
  padding: 12px 16px;
  border: none;
  background: transparent;
  color: #6c757d;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-status:focus {
  outline: none;
}

.text-danger {
  color: #dc3545 !important;
  font-size: 12px;
}

.is-invalid {
  border-color: #dc3545 !important;
}

/* Responsive adjustments */
@media (min-width: 768px) {}

@media (min-width: 992px) {
  .status-buttons {
    max-width: 400px;
    margin: 20px auto;
  }
}


/* Mejoras visuales adicionales */
.card {
  transition: all 0.3s ease;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1) !important;
}

/* Estilo para input de cantidad */
.form-control-lg.text-center:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
  background-color: #f8f9ff;
}

/* Animación suave para el placeholder */
.form-control::placeholder {
  color: #dee2e6;
  transition: color 0.2s ease;
}

.form-control:focus::placeholder {
  color: transparent;
}

/* Select personalizado */
.custom-select:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
}

/* Badge mejorado */
.badge-pill {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.input-border-label {
  background: #f8f9fa;
}

/* Responsive adjustments */
@media (max-width: 576px) {
  .form-control-lg.text-center {
    font-size: 2rem !important;
    height: 4rem !important;
  }

  .card-body {
    padding: 1.5rem !important;
  }
}

/* Motivos: input de agregar (select + cantidad + boton) */
.motivo-add-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: stretch;
}

.motivo-select {
  flex: 1 1 60%;
  min-width: 0;
}

.motivo-cantidad {
  flex: 1 1 80px;
  max-width: 100px;
}

.motivo-add-btn {
  flex: 0 0 auto;
  min-width: 44px;
}

.motivo-remove-btn {
  min-width: 32px;
  min-height: 32px;
}

.motivo-list {
  max-height: 260px;
  overflow-y: auto;
}

/* En pantallas muy angostas (handhelds), el select ocupa todo el ancho
   y la cantidad + boton quedan en la misma fila debajo */
@media (max-width: 400px) {
  .motivo-select {
    flex: 1 1 100%;
  }

  .motivo-cantidad {
    flex: 1 1 auto;
    max-width: none;
  }

  .motivo-add-btn {
    min-width: 48px;
  }
}
</style>